// React
import { Fragment } from 'react'

// Components
import { Divider, FormControlLabel, ListItemText, Radio } from '@mui/material'

// Styled
import { styled } from '@mui/material/styles'

import { HallType } from '@weblite/ts-action/hall'

// Localization
import { t } from '$setup/internationalization'

const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: -25px;
`

const IntendedDivider = styled(Divider)`
  margin-right: 45px;

  &:last-child {
    display: none;
  }
`

interface Prop {
  hallType: HallType
  accessibility: string
  handleIsPublic: () => unknown
}
export function RadioButtonListItem({
  hallType,
  handleIsPublic,
  accessibility,
}: Prop) {
  return (
    <Fragment>
      <StyledFormControlLabel
        value={accessibility}
        control={<Radio sx={{ margin: '22px' }} onClick={handleIsPublic} />}
        label={
          <ListItemText
            primary={t(
              `hallAccessibility.access.${accessibility}.${hallType.toLowerCase()}.title`,
            )}
            secondary={t(
              `hallAccessibility.access.${accessibility}.${hallType.toLowerCase()}.description`,
            )}
            primaryTypographyProps={{ variant: 'body2' }}
            secondaryTypographyProps={{ variant: 'caption1' }}
          />
        }
      />
      <IntendedDivider />
    </Fragment>
  )
}
